// Traduções do dialog da imagem da escala — coletadas por glob em core/i18n/messages.ts.
// O CONTEÚDO da imagem em si é pt-BR fixo (padrão WhatsApp do cliente, escalaImagem.ts).
export default {
  pt: {
    'shipments.escalaImagem.abrir': 'Gerar imagem da escala',
    'shipments.escalaImagem.titulo': 'Imagem da escala do dia',
    'shipments.escalaImagem.dia': 'Dia do carregamento',
    'shipments.escalaImagem.previewAlt': 'Prévia da imagem da escala do dia',
    'shipments.escalaImagem.copiarImagem': 'Copiar imagem',
    'shipments.escalaImagem.baixarPng': 'Baixar PNG',
    'shipments.escalaImagem.baixarExcel': 'Baixar Excel',
    'shipments.escalaImagem.copiarTexto': 'Copiar texto',
    'shipments.escalaImagem.imagemCopiada': 'Imagem da escala copiada.',
    'shipments.escalaImagem.copiaImagemFalhou': 'Não foi possível copiar a imagem. Use Baixar PNG.',
    'shipments.escalaImagem.baixarFalhou': 'Não foi possível gerar o PNG. Tente novamente.',
    'shipments.escalaImagem.copiaNaoSuportada': 'Este navegador não copia imagens. Use Baixar PNG.',
    'shipments.escalaImagem.textoCopiado': 'Mensagem da programação copiada.',
    'shipments.escalaImagem.textoCopiaFalhou': 'Não foi possível copiar. Tente novamente.',
    'shipments.escalaImagem.semCargas': 'Nenhum dia com cargas para gerar a escala.',
  },
  en: {
    'shipments.escalaImagem.abrir': 'Generate schedule image',
    'shipments.escalaImagem.titulo': 'Daily schedule image',
    'shipments.escalaImagem.dia': 'Loading day',
    'shipments.escalaImagem.previewAlt': 'Preview of the daily schedule image',
    'shipments.escalaImagem.copiarImagem': 'Copy image',
    'shipments.escalaImagem.baixarPng': 'Download PNG',
    'shipments.escalaImagem.baixarExcel': 'Download Excel',
    'shipments.escalaImagem.copiarTexto': 'Copy text',
    'shipments.escalaImagem.imagemCopiada': 'Schedule image copied.',
    'shipments.escalaImagem.copiaImagemFalhou': 'Could not copy the image. Use Download PNG.',
    'shipments.escalaImagem.baixarFalhou': 'Could not generate the PNG. Try again.',
    'shipments.escalaImagem.copiaNaoSuportada': 'This browser cannot copy images. Use Download PNG.',
    'shipments.escalaImagem.textoCopiado': 'Schedule message copied.',
    'shipments.escalaImagem.textoCopiaFalhou': 'Could not copy. Try again.',
    'shipments.escalaImagem.semCargas': 'No days with shipments to build the schedule.',
  },
  es: {
    'shipments.escalaImagem.abrir': 'Generar imagen de la escala',
    'shipments.escalaImagem.titulo': 'Imagen de la escala del día',
    'shipments.escalaImagem.dia': 'Día de carga',
    'shipments.escalaImagem.previewAlt': 'Vista previa de la imagen de la escala del día',
    'shipments.escalaImagem.copiarImagem': 'Copiar imagen',
    'shipments.escalaImagem.baixarPng': 'Descargar PNG',
    'shipments.escalaImagem.baixarExcel': 'Descargar Excel',
    'shipments.escalaImagem.copiarTexto': 'Copiar texto',
    'shipments.escalaImagem.imagemCopiada': 'Imagen de la escala copiada.',
    'shipments.escalaImagem.copiaImagemFalhou': 'No se pudo copiar la imagen. Use Descargar PNG.',
    'shipments.escalaImagem.baixarFalhou': 'No se pudo generar el PNG. Inténtelo de nuevo.',
    'shipments.escalaImagem.copiaNaoSuportada': 'Este navegador no copia imágenes. Use Descargar PNG.',
    'shipments.escalaImagem.textoCopiado': 'Mensaje de programación copiado.',
    'shipments.escalaImagem.textoCopiaFalhou': 'No se pudo copiar. Inténtelo de nuevo.',
    'shipments.escalaImagem.semCargas': 'Ningún día con cargas para generar la escala.',
  },
}
